module.exports = __webpack_public_path__ + "img/report_top.198a677f.png";